/**
 * Removes null, undefined, and zero values from an object recursively.
 * Preserves parent structure even if nested objects become empty.
 *
 * @param obj - The object to clean.
 * @returns A new object without null, undefined, and zero values.
 */

export function removeNullAndZeroValues<
  T extends Record<string, $TSMigrationFixMe>
>(obj: T): T {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    // Skip null, undefined, zero values, and empty strings
    if (
      value === null ||
      value === undefined ||
      value === 0 ||
      value === "" ||
      (typeof value === "string" && value.trim() === "")
    ) {
      return acc
    }

    // Recursively clean nested objects but always preserve them
    if (
      typeof value === "object" &&
      !Array.isArray(value) &&
      !(value instanceof Date)
    ) {
      acc[key as keyof T] = removeNullAndZeroValues(value) as $TSMigrationFixMe
      return acc
    }

    acc[key as keyof T] = value
    return acc
  }, {} as T)
}
